import Components from '../../Components';
import { getIsManager } from '../../Core/Utils/userPermissions';
import { MANAGE_DESKS_PATH } from './constants';

const { containerTypes } = Components.Routes;

const RouteConfig = {
  path: MANAGE_DESKS_PATH,
  exact: true,
  name: 'navigation.menu.manageDesks',
  private: true,
  type: containerTypes.PAGE,
  requiresMemberPortalAccess: true,
  isAuthorized: ({ profile }) => {
    return getIsManager(profile);
  },
};

export default RouteConfig;
